/**
 * Setzt eine umsortierte TEILliste zurueck in die Gesamtreihenfolge: die sichtbaren Eintraege
 * belegen in neuer Reihenfolge genau die Plaetze, die sie vorher in `alle` hatten — ausgeblendete
 * Eintraege (z. B. archivierte Pakete bei „Archivierte zeigen“ aus) bleiben, wo sie sind.
 */
export function teilReihenfolgeEinsetzen(alle: string[], sichtbarNeu: string[]): string[] {
  const sichtbar = new Set(sichtbarNeu);
  let i = 0;
  return alle.map((id) => (sichtbar.has(id) ? sichtbarNeu[i++]! : id));
}
